'use client'

import { useState, useEffect } from 'react'
import MentorGrid from './MentorGrid'
import Link from 'next/link'
import { Button } from '@mantine/core'
import { UserWithMentor } from '@/types/mentor'

export default function HomeMentorGridWrapper() {
  const [users, setUsers] = useState<UserWithMentor[]>([])
  const [loading, setLoading] = useState(true)
  
  useEffect(() => {
    fetch('/api/mentors?limit=6')
      .then(res => res.json())
      .then(data => {
        setUsers(data)
        setLoading(false)
      })
      .catch(err => {
        console.error('Failed to load mentors:', err)
        setLoading(false)
      })
  }, [])
  
  return (
    <div style={{ position: 'relative', zIndex: 10 }}>
      <MentorGrid users={users} loading={loading} />
      <div style={{ textAlign: 'center', marginTop: '2rem' }}>
        <Link href="/mentors" style={{ textDecoration: 'none' }}>
          <Button size="lg" variant="outline" color="navy">
            See more mentors
          </Button>
        </Link>
      </div>
    </div>
  )
}
